<template>
  <div
    style="height: 120px; display: flex; flex-direction: column; justify-content: center; align-items: center;">
    <div style="display: flex; justify-content: center; align-items: center">
      <el-avatar :size="64" :src="$store.state.user.avatarUrl || defaultAvatarUrl"></el-avatar>
      <div style="margin-left: 20px; font-size: 14px">
        <div>
          <label style="font-size: 20px; font-weight: bold">{{$store.state.user.name}}</label>
          <label v-if="$isTechnician()"> - {{technicianTypeName}}</label>
        </div>
        <div v-if="$store.state.user.teamId">隶属工组: {{$store.state.user.team.name}}</div>
      </div>
      <van-button v-if="showStartWork" size="small" plain round type="info" style="margin-left: 16px; width: 60px"
                  @click="startWork">
        开工
      </van-button>
    </div>
    <div v-if="$store.state.user.teamId" style="margin-top: 10px; font-size: 15px">
      工作范围: {{$store.state.user.workScope.map(procedure => procedure.name).join(', ')}}
    </div>
  </div>
</template>

<script>
  import { defaultAvatarUrl } from '@/utils/const'
  import { shareDataMixin } from '@/views/mixins/ShareData'
  import { Button } from 'vant'

  export default {
    inject: ['reload', 'resetPage'],
    name: 'WxMyProfile',
    mixins: [shareDataMixin],
    components: {
      [Button.name]: Button
    },
    props: {
      showStartWork: Boolean
    },
    data () {
      return {
        defaultAvatarUrl
      }
    },
    methods: {
      startWork () {
        this.resetPage()
        this.reload(1)
      }
    },
    computed: {
      technicianTypeName () {
        if (!this.$isTechnician()) return ''
        return this.technicianTypeMap[this.$store.state.user.technicianType]
      }
    }
  }
</script>

<style scoped>

</style>
